import React from 'react';
import NavBar from '../comp/NavBar';
import CompAbout from '../comp/CompAbout';
import Footer from '../comp/Footer';

export default class ScMain extends React.Component<any, any> {
  render() {
    return (
      <div>
        <NavBar />
        <section
          id="hero"
          className="d-flex align-items-center justify-content-center">
          <div className="container" data-aos="fade-up">
            <div
              className="row justify-content-center"
              data-aos="fade-up"
              data-aos-delay="150">
              <div className="col-xl-6 col-lg-8">
                <h1>
                  A bridge to build a smart city<span>.</span>
                </h1>
                <h2>
                  We provide environmental technology, IoT, and data analysis
                  technology.
                </h2>
              </div>
            </div>
            <div
              className="row gy-4 mt-5 justify-content-center"
              data-aos="zoom-in"
              data-aos-delay="250">
              <div className="col-xl-2 col-md-4">
                <div className="icon-box">
                  <i className="ri-store-line"></i>
                  <h3>
                    <a href="#features">
                      Bigdata processing,
                      <br />
                      analysis
                    </a>
                  </h3>
                </div>
              </div>
              <div className="col-xl-2 col-md-4">
                <div className="icon-box">
                  <i className="ri-bar-chart-box-line"></i>
                  <h3>
                    <a href="#features">
                      IoT monitoring system <br />
                      device control
                    </a>
                  </h3>
                </div>
              </div>
              <div className="col-xl-2 col-md-4">
                <div className="icon-box">
                  <i className="ri-calendar-todo-line"></i>
                  <h3>
                    <a href="#services">Crowd B2B Sales Platform</a>
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </section>

        <main id="main">
          <section id="about" className="about">
            <CompAbout />
          </section>

          <section id="features" className="features">
            <div className="container" data-aos="fade-up">
              <div className="section-title">
                <h2>Big data processing</h2>
                <p>Features</p>
              </div>
              <div className="row">
                <div className="image col-lg-6" data-aos="fade-right">
                  <img className="img-fluid" src="../assets/img/apm.png" />
                </div>
                <div
                  className="col-lg-6"
                  data-aos="fade-left"
                  data-aos-delay="100">
                  <div
                    className="icon-box mt-5 mt-lg-0"
                    data-aos="zoom-in"
                    data-aos-delay="150">
                    <i className="bx bx-receipt"></i>
                    <h4>Flexible system operation</h4>
                    <p>
                      It is packaged to enable operation on bare metal systems
                      and containers such as Docker and Kubernetes, allowing
                      flexible configuration depending on the data capacity
                      being collected..
                    </p>
                  </div>
                  <div
                    className="icon-box mt-5"
                    data-aos="zoom-in"
                    data-aos-delay="150">
                    <i className="bx bx-cube-alt"></i>
                    <h4>Opensource</h4>
                    <p>
                      Depending on the purpose of data analysis, an analysis
                      system can be developed and applied using various data
                      storage such as elasticsearch and mariadb.
                    </p>
                  </div>
                  <div
                    className="icon-box mt-5"
                    data-aos="zoom-in"
                    data-aos-delay="150">
                    <i className="bx bx-images"></i>
                    <h4>Customized to fit your application</h4>
                    <p>
                      It is built in conjunction with measuring instruments and
                      RTUs used in BEMS, FEMS, etc. We develop dashboards and
                      screens according to user needs and build them to suit
                      their needs.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/*
                    <section id="cta" className="cta">
                        <div className="container" data-aos="zoom-in">

                            <div className="text-center">
                                <h3></h3>
                                <p> Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu
                                    fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa
                                    qui officia deserunt mollit anim id est laborum.</p>
                                <a className="cta-btn" href="#">Call To Action</a>
                            </div>

                        </div>
                    </section>
*/}

          {/*                    <section id="counts" className="counts">
                        <div className="container" data-aos="fade-up">
                            <div className="section-title">
                                <h2>IoT data collection, control</h2>
                                <p>Features</p>
                            </div>

                            <div className="row no-gutters">
                                <div
                                    className="image col-xl-5 d-flex align-items-stretch justify-content-center justify-content-lg-start"
                                    data-aos="fade-right" data-aos-delay="100"></div>
                                <div className="col-xl-7 ps-4 ps-lg-5 pe-4 pe-lg-1 d-flex align-items-stretch"
                                     data-aos="fade-left" data-aos-delay="100">
                                    <div className="content d-flex flex-column justify-content-center">
                                        <h3>Voluptatem dignissimos provident quasi</h3>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                                            tempor incididunt ut labore et dolore magna aliqua. Duis aute irure dolor in
                                            reprehenderit
                                        </p>
                                        <div className="row">
                                            <div className="col-md-6 d-md-flex align-items-md-stretch">
                                                <div className="count-box">
                                                    <i className="bi bi-emoji-smile"></i>
                                                    <span data-purecounter-start="0" data-purecounter-end="65"
                                                          data-purecounter-duration="2" className="purecounter"></span>
                                                    <p><strong>Happy Clients</strong> consequuntur voluptas nostrum
                                                        aliquid ipsam architecto ut.</p>
                                                </div>
                                            </div>

                                            <div className="col-md-6 d-md-flex align-items-md-stretch">
                                                <div className="count-box">
                                                    <i className="bi bi-journal-richtext"></i>
                                                    <span data-purecounter-start="0" data-purecounter-end="85"
                                                          data-purecounter-duration="2" className="purecounter"></span>
                                                    <p><strong>Projects</strong> adipisci atque cum quia aspernatur
                                                        totam laudantium et quia dere tan</p>
                                                </div>
                                            </div>

                                            <div className="col-md-6 d-md-flex align-items-md-stretch">
                                                <div className="count-box">
                                                    <i className="bi bi-clock"></i>
                                                    <span data-purecounter-start="0" data-purecounter-end="35"
                                                          data-purecounter-duration="4" className="purecounter"></span>
                                                    <p><strong>Years of experience</strong> aut commodi quaerat modi
                                                        aliquam nam ducimus aut voluptate non vel</p>
                                                </div>
                                            </div>

                                            <div className="col-md-6 d-md-flex align-items-md-stretch">
                                                <div className="count-box">
                                                    <i className="bi bi-award"></i>
                                                    <span data-purecounter-start="0" data-purecounter-end="20"
                                                          data-purecounter-duration="4" className="purecounter"></span>
                                                    <p><strong>Awards</strong> rerum asperiores dolor alias quo
                                                        reprehenderit eum et nemo pad der</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </section>*/}

          <section id="services" className="services">
            <div className="container" data-aos="fade-up">
              <div className="section-title">
                <h2>Services</h2>
                <p>Check our Services</p>
              </div>
              <div className="row">
                <div
                  className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4"
                  data-aos="zoom-in"
                  data-aos-delay="100">
                  <div className="icon-box">
                    <div className="icon">
                      <i className="bx bxl-dribbble"></i>
                    </div>
                    {/*<h4><a href="http://www.ecc.town" target={'_blank'} rel="noreferrer">ecc</a>*/}
                    <h4>
                      <a href="#">ecc</a>
                    </h4>
                    <p>
                      <strong>Eco Collection & Cloud</strong>
                    </p>
                    <p>
                      We provide an environmental technology portal service that
                      integrates environmental technology. &nbsp;
                      <span className={'badge text-bg-success'}>
                        Open in May 2024
                      </span>
                    </p>
                  </div>
                </div>
                <div
                  className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4"
                  data-aos="zoom-in"
                  data-aos-delay="200">
                  <div className="icon-box">
                    <div className="icon">
                      <i className="bx bx-file"></i>
                    </div>
                    <h4>
                      <a
                        href="http://www.neosales.co.kr"
                        target={'_blank'}
                        rel="noreferrer">
                        neo sales
                      </a>
                    </h4>
                    <p>
                      <strong>Crowd B2B Sales Platform</strong>
                    </p>
                    <p>
                      You can secure various sales channels by utilizing
                      freelance salespeople registered with neo sales.&nbsp;{' '}
                      <br />
                      <span className={'badge text-bg-primary'}>KOREAN</span>
                    </p>
                  </div>
                </div>
                <div
                  className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4"
                  data-aos="zoom-in"
                  data-aos-delay="300">
                  <div className="icon-box">
                    <div className="icon">
                      <i className="bx bx-data"></i>
                    </div>
                    <h4>
                      <a
                        href="/data/water-treatment/index.html"
                        target={'_blank'}
                        rel={'noreferrer'}>
                        Data visualization
                      </a>
                    </h4>
                    <p>
                      <strong>Data visualize functions in platform</strong>
                    </p>
                    <p>
                      Data visualization can be performed more easily with ECC
                      platform. <br />
                      <a
                        href="/data/water-treatment/index.html"
                        target={'_blank'}
                        rel={'noreferrer'}>
                        <span className={'badge text-bg-primary'}>
                          view sample
                        </span>
                      </a>
                      &nbsp;
                    </p>
                  </div>
                </div>
                <div
                  className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4"
                  data-aos="zoom-in"
                  data-aos-delay="300">
                  <div className="icon-box">
                    <div className="icon">
                      <i className="bx bx-tachometer"></i>
                    </div>
                    <h4>
                      <a href="#">able town</a>
                    </h4>
                    <p>
                      <strong>A town where everything is possible</strong>
                    </p>
                    <p>
                      You can hear stories from various people who want to work
                      and live abroad. &nbsp;
                      <span className={'badge text-bg-success'}>
                        Open in 2024. 4Q
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section id="contact" className="contact">
            <div className="container" data-aos="fade-up">
              <div className="section-title">
                <h2>Contact</h2>
                <p>Contact Us</p>
              </div>

              <div></div>

              <div className="row mt-5">
                <div className="col-lg-4">
                  <div className="info">
                    <div className="address">
                      <i className="bi bi-geo-alt"></i>
                      <h4>Location:</h4>
                      <p>
                        606ho(6F) 445, Heungan-daero, Dongan-gu, Anyang-si,
                        Gyeonggi-do, Republic of Korea
                      </p>
                    </div>

                    <div className="email">
                      <i className="bi bi-envelope"></i>
                      <h4>Email:</h4>
                      <p>rimocast@rimocast.com</p>
                    </div>
                  </div>
                </div>
                <div className={'col-lg-8'}>
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d593.6691782538484!2d126.97481390845607!3d37.3942521565063!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b5f5a2fe93b61%3A0x38c9dac2eeaa703c!2z7Y-J7LSMS-u5hOymiOumrOybgA!5e0!3m2!1sko!2skr!4v1708592408268!5m2!1sko!2skr"
                    width="600"
                    height="450"
                    style={{border: 0, width: '100%', height: '270px'}}
                    allowFullScreen={true}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"></iframe>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    );
  }
}
